import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import Navbar from '../../components/Navbar'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import cheques_img1 from "../../assets/images/contents/cheques-1.png"
import cheques_img2 from "../../assets/images/contents/cheques-2.png"
import cheques_img3 from "../../assets/images/contents/cheques-3.jpg"
import { PrimaryButton, SecondaryButton } from '../../components/StyledButtons'
import { LinkWhiteHoverOrange } from '../../components/StyledComponents'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'
import ModalContactGetTrialForm from '../../components/ModalContactGetTrialForm'


const Cheques = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const [modalGetTrialOpen, setModalGetTrialOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const modalGetTrialRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
        if (modalGetTrialRef.current && !modalGetTrialRef.current.contains(event.target)) {
            setModalGetTrialOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalGetTrialOpen(false)
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='cheques bg-primary'>
            <div className='color-filter-right' style={{ top: "20%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "52%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-right' style={{ top: "70%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <Navbar />
            <div className='container-fluid cheques-header pb-100'>
                <div className='container'>

                    {language === "en" ?
                        <div className='col-sm-8 col-sm-offset-2 pt-150'>
                            <div className='font-weight-bold text-center font-64 cheques-header-title'>CHEQUES</div>
                            <div className='col-sm-10 col-sm-offset-1'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                        :
                        <div className='col-sm-6 col-sm-offset-3 pt-150'>
                            <div className='font-weight-bold text-center font-64 cheques-header-title'>SÉC</div>
                            <div className='col-sm-10 col-sm-offset-1'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                    }
                    <div className='col-sm-12 flex justify-center pt-50 px-0'>
                        <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.cheques')} linkToPrevPage="/industries" />
                    </div>
                </div>


            </div>
            <div className='cheques-content container'>
                <div className='row flex-lg'>
                    <div className='col-lg-w-400'>
                        <IndustriesStickyMenu bankingAndFinancialActive={true} chequesActive={true} />
                    </div>
                    <div className='col-lg-w--400 cheques-content_info'>

                        <p className='font-48 font-weight-semibold text-white'>{t('cheques.title')}</p>
                        <p className='text-white pt-20 font-weight-medium font-20'>{t('cheques.sub-title-1')}</p>
                        <p className='text-white pt-20'>{t('cheques.content-1-1')}</p>
                        <p className='text-white pt-20'>{t('cheques.content-1-2')}</p>
                        <p className='text-white pt-20'>{t('cheques.content-1-3')}</p>
                        <p className='text-white pt-20 font-weight-medium font-20'>{t('cheques.sub-title-2')}</p>
                        <p className='text-white pt-20'>{t('cheques.content-2-1')}</p>
                        <div className='pt-50'>
                            <img src={cheques_img1} alt="" className='img-responsive' />
                        </div>
                        <p className='text-white pt-50'>{t('cheques.content-2-2')}</p>
                        <div className='col-sm-12 pt-30 px-0'>
                            <p className='text-white font-weight-medium'>{t('cheques.content-2-3')}</p>
                            <ul className='list-unstyled pt-20'>
                                <li className='checked-line'>{t('cheques.content-2-3-1')}</li>
                                <li className='checked-line'>{t('cheques.content-2-3-2')}</li>
                                <li className='checked-line'>{t('cheques.content-2-3-3')}</li>
                                <li className='checked-line'>{t('cheques.content-2-3-4')}</li>
                                <li className='checked-line'>{t('cheques.content-2-3-5')}</li>
                            </ul>
                        </div>
                        <div className='col-sm-12'>
                            <div className='row'>
                                <p className='text-white pt-20 font-weight-medium font-20'>{t('cheques.sub-title-3')}</p>

                                <p className='text-white pt-20'>{t('cheques.content-3-1')}</p>

                                <div className='pt-50'>
                                    <img src={cheques_img2} alt="" className='img-responsive' />
                                </div>
                                <p className='text-white pt-30'>{t('cheques.content-3-2')}</p>
                                <p className='text-white pt-20 font-weight-medium font-20'>{t('cheques.sub-title-4')}</p>
                                <p className='pt-20 text-white'>{t('cheques.content-4-1')}</p>
                            </div>
                        </div>
                        <div className='col-sm-12 pt-30 px-0'>
                            <p className='text-white font-weight-medium'>{t('cheques.content-4-2')}</p>
                            <ul className='list-unstyled pt-20'>
                                <li className='checked-line'>{t('cheques.content-4-2-1')}</li>
                                <li className='checked-line'>{t('cheques.content-4-2-2')}</li>
                                <li className='checked-line'>{t('cheques.content-4-2-3')}</li>
                                <li className='checked-line'>{t('cheques.content-4-2-4')}
                                </li>
                            </ul>
                        </div>
                        <div className='col-sm-12 pt-50'>
                            <div className='row'>
                                <img src={cheques_img3} alt="" className='img-responsive' />
                            </div>
                        </div>
                        <div className='col-sm-12 pt-30'>
                            <div className='row'>
                                <LinkWhiteHoverOrange href="/technology">{t('cheques.content-5')}</LinkWhiteHoverOrange>
                            </div>
                        </div>
                        <div className='col-sm-12 pt-30'>
                            <div className='row'>
                                <SecondaryButton
                                 onClick={() => setModalGetTrialOpen(true)}
                                >{t('button.get-a-free-trial')}</SecondaryButton>
                            </div>
                        </div>
                        <div className='col-sm-12 pt-30'>
                            <div className='row'>
                                <PrimaryButton
                                    onClick={() => setModalDiscussionOpen(true)}
                                >{t('button.schedule-discussion')}</PrimaryButton>
                            </div>
                        </div>
                    </div>
                </div>
                <IndustriesImageContainer />
            </div>

            <Footer />

            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
            {modalGetTrialOpen && <ModalContactGetTrialForm
                setOpenModal={setModalGetTrialOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalGetTrialRef} />}
        </div>
    )
}

export default Cheques